var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.75 4.16667V2.5M6.25 4.16667V2.5M2.70833 6.66667H17.2917M2.5 10C2.5 6.46417 2.5 5.53 3.59833 4.43167C4.69667 3.33333 6.465 3.33333 10 3.33333C13.5358 3.33333 15.3033 3.33333 16.4017 4.43167C17.5 5.53 17.5 6.465 17.5 10C17.5 13.5358 17.5 15.3033 16.4017 16.4017C15.3033 17.5 13.535 17.5 10 17.5C6.46417 17.5 4.69667 17.5 3.59833 16.4017C2.5 15.3033 2.5 13.535 2.5 10Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR3);
export default __webpack_public_path__ + "static/media/r3.2b7bf9efd2fe8ef6d4908e2c15596c4b.svg";
export { ForwardRef as ReactComponent };